module.exports = __webpack_public_path__ + "static/media/screen8.16a7a317.png";